var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed w-screen h-screen top-0 left-0 bg-black-20 z-10"})}
var staticRenderFns = []

export { render, staticRenderFns }